@if (!reviewOnEdit) {
    <h2>Bewertung verfassen</h2>
} @else if (reviewOnEdit) {
    <h2>Bewertung bearbeiten</h2>
}

<div [formGroup]="form">
    <div class="titel-stars">
        <div class="headline">
            <mat-form-field style="width: 80%">
                <mat-label>Geben Sie den Titel ein</mat-label>
                <input matInput formControlName="titel"
                    style="padding-left: 10.5px;" class="input-titel" required maxlength="101"
                    [errorStateMatcher]="titelErrorStateMatcher" />
                <mat-error>
                    {{ getErrorMessageTitel() }}
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <h3>Ihre Bewertung*</h3>
        </div>
        <div style="margin-top: -1vh">
            <app-star [veryBig]="true" (starClickEmitter)="setCurrentRating($event)"
                (starHoverEmitter)="hoverEnter($event)" (starHoverEmitter)="hoverLeave($event)"
                [rating]="hoverstate || currentRating"></app-star>
        </div>
        <div class="user-orga-grid">
            <mat-form-field style="width: 47%" appearance="outline">
                <mat-label>Benutzer*</mat-label>
                <input matInput [value]="
                        userService.currentUser.firstName +
                        ' ' +
                        userService.currentUser.lastName
                    " disabled />
            </mat-form-field>
            <mat-form-field style="width: 47%" appearance="outline">
                <mat-label>Organisation</mat-label>
                <input matInput formControlName="organisation" />
            </mat-form-field>
        </div>
    </div>
    <div>
        <h3>Ihr Kommentar*</h3>
    </div>
    <div style="margin-top: -14px; margin-bottom: 8px;">
        <mat-form-field class="input" appearance="outline">
            <textarea matInput rows="10" cols="30" formControlName="feedback"
                placeholder="Verfassen Sie eine Bewertung." required maxlength="10001"
                [errorStateMatcher]="feedbackErrorStateMatcher">
            </textarea>
            <mat-error>
                {{ getErrorMessageFeedback() }}
            </mat-error>
        </mat-form-field>
    </div>
    <div style="display: flex; justify-content: flex-start">
        <p style="
                font-size: 14px;
                margin-top: -4px;
            ">
            *Pflichtfeld
        </p>
        <div class="buttons">
            <button matButton="elevated" color="warn" (click)="cancel()">
                Abbrechen
            </button>
            <button matButton="elevated" class="green-confirm" (click)="sendReview()"
                [disabled]="form.invalid || currentRating === 0 || isLoading">
                Bewertung absenden
            </button>
        </div>
    </div>
</div>
<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>